import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Search, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import "./pendingReports.css";
import ReportCard from "../../../../components/reviewer/reportCards/reportCard";
import { motion } from "framer-motion";
import { useSse } from "../../../../components/sseProvider/sseProvider";

const PendingReports = () => {
  const API_ENDPOINT = process.env.REACT_APP_API_END_POINT;
  const [reports, setreports] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [moduleFilter, setModuleFilter] = useState("");
  const es = useSse();

  const getPendingReports = useCallback(async () => {
    try {
      const response = await axios.get(
        `${API_ENDPOINT}/api/ReviewerReports/GetPendingReports`,
        {
          withCredentials: true,
          headers: { "Content-Type": "application/json" },
        }
      );
      if (response?.data?.status) {
        setreports(response.data.pendingReports);
        console.log("Latest reports fetched successfully");
        console.log("Message" + response.data.message);
        console.log(response.data.pendingReports);
      } else {
        setreports([]);
        console.log("Failed to fetch Latest reports" + response?.data);
      }
    } catch (error) {
      setreports([]);
      console.log("An error occurred");
    }
  }, [API_ENDPOINT]);
  useEffect(() => {
    getPendingReports();
    if (!es) return;

    const handler = (e) => {
      getPendingReports();
    };

    es.addEventListener("report_update", handler);

    return () => {
      es.removeEventListener("report_update", handler);
    };
  }, [getPendingReports, es]);

  const getStatusLabel = (report) => {
    if (!report.status) return "Pending";
    return report.hasFeedback ? "Reviewed with Feedback" : "Reviewed";
  };

  const matchesStatusFilter = (report) => {
    const label = getStatusLabel(report);
    if (statusFilter === "all") return true;
    if (statusFilter === "reviewed") return label === "Reviewed";
    if (statusFilter === "feedback") return label === "Reviewed with Feedback";
    if (statusFilter === "pending") return label === "Pending";
    return false;
  };

  const moduleCodes = Array.from(
    new Set(reports.map((r) => r.moduleCode).filter(Boolean))
  );

  const filteredReports = reports
    .filter((report) =>
      moduleFilter ? report.moduleCode === moduleFilter : true
    )
    .filter((report) =>
      searchTerm
        ? (report.moduleName || "")
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          (report.moduleCode || "")
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
        : true
    )
    .filter(matchesStatusFilter);
  return (
    <main className="pending-report-main">
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="page-header-left">
          <Link
            onClick={() => window.history.back()}
            className="back-icon-button"
          >
            <ArrowLeft />
          </Link>
          <div className="admin-dashboard-header">
            <h2 className="admin-header-text">Pending Reports</h2>
          </div>
        </div>
      </motion.div>

      <div className="card search-filter">
        <div className="reviewer-reports-list-container">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="reviewer-search-container"
          >
            <div className="admin-search-box">
              <div className="admin-search-icon">
                <Search className="icon" />
              </div>
              <input
                type="search"
                placeholder="Search Report..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* <select
              className="admin-dropdown"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="all">All Reports</option>
              <option value="pending">Pending</option>
              <option value="reviewed">Reviewed</option>
              <option value="feedback">Reviewed With Feedback</option>
            </select> */}

            <select
              className="admin-dropdown"
              value={moduleFilter}
              onChange={(e) => setModuleFilter(e.target.value)}
            >
              <option value="">All Modules</option>
              {moduleCodes.map((code) => (
                <option key={code} value={code}>
                  {code}
                </option>
              ))}
            </select>
          </motion.div>

          <div className="reviewer-report-list">
            <div className="report-wrapper">
              {filteredReports.length > 0 ? (
                filteredReports.map((report) => (
                  <ReportCard key={report.reportId} report={report} />
                ))
              ) : (
                <p style={{ padding: "20px", textAlign: "center" }}>
                  No matching reports found.
                </p>
              )}
            </div>
          </div>
        </div>

        {reports.length === 0 && (
          <div className="card no-data">
            <p>No Reports found.</p>
          </div>
        )}
      </div>
    </main>
  );
};

export default PendingReports;
